import React, { useEffect, useState } from 'react';

import { Input } from '@progress/kendo-react-inputs';
import { Button } from '@progress/kendo-react-buttons';
import { GenCombobox } from '@jeru-react/core/dropdowns';
import { useLocation } from "react-router-dom";
//compoenets:
import SvgIcon from "../CustomeComponents/SvgIcon"
import OrHrDivider from './OrHrDivider';
//server funcs:
import { fetchGushimList, fetchStreetsList, fetchTabasList, fetchHelkotByGushId } from "../server/ServerFunc"

const TikRishuiRegistration = (props) => {
    const [tikNumYear, setTikNumYear] = useState("");
    const [tikNumValue, setTikNumValue] = useState("");
    const [isBakshaSerch, setIsBakshaSearch] = useState(false);

    const [gushimList, setGushimList] = useState([]);
    const [misparGush, setMisparGush] = useState("");
    const [helkotList, setHelkotList] = useState([]);
    const [misparHelka, setMisparHelka] = useState("");
    const [isGushVeHelkaSearch, setIsGushVeHelkaSearch] = useState(false);

    const [streetsList, setStreetsList] = useState([]);
    const [streetNum, setStreetNum] = useState("");
    const [streetName, setStreetName] = useState("");
    const [misparBait, setMisparBait] = useState("");
    const [isStreetNumVeMisparBait, setIsStreetNumVeMisparBait] = useState(false);

    const [tabasList, setTabasList] = useState([]);
    const [misparTaba, setMisparTaba] = useState("");
    const [misparTaShetach, setMisparTaShetach] = useState("");
    const [isMisparTabaVeShetach, setIsMisparTabaVeShetach] = useState(false);

    const [misparTikTaba, setMisparTikTaba] = useState("");
    const [isMisparTaba, setIsMisparTaba] = useState(false);

    const [misparHeytelYear, setMisparHeytelYear] = useState("");
    const [misparHeytelTik, setMisparHeytelTik] = useState("");
    const [misparAsmachta, setMisparAsmachta] = useState("");
    const [misparTofet, setMisparTofes] = useState("");

    const [isLoading, setIsLoading] = useState(false);

    const search = useLocation().search;

    //get parameter from URL
    const systemCodeURL = new URLSearchParams(search).get("SystemCode");

    useEffect(() => {
        getGushimData();
        getStreetsData();
        getTabasData();
    }, []);

    useEffect(() => {
        if (misparGush !== "" && misparGush !== null) {
            getHelkotByGushId(misparGush);
        }
    }, [misparGush])

    //server funcs:
    const isDataStale = (dataName) => {
        const storedData = JSON.parse(localStorage.getItem(`${dataName}`));
        if (!storedData)
            return true; // Data doesn't exist, or it's corrupted
      
        const lastSavedDate = new Date(storedData.lastSavedDate);
        const oneWeekAgo = new Date();
        oneWeekAgo.setDate(oneWeekAgo.getDate() - 7); // Subtract 7 days

        return lastSavedDate < oneWeekAgo;
    }

    const getGushimData = async () => {
        if (isDataStale('gushim')) {
            const gushimData = await fetchGushimList();
    
            if (gushimData && gushimData.length > 0) {
                // Save the data and current date in local storage
                const currentDate = new Date();
                localStorage.setItem('gushim', JSON.stringify({ gushimData, lastSavedDate: currentDate }));
    
                let gushimArr = [];
                for (let i = 0; i < gushimData.length; i++) {
                    let gushObj = {
                        value: gushimData[i].gush,
                        text: `${gushimData[i].gush + 0}`
                    }
                    gushimArr.push(gushObj);
                }
                setGushimList(gushimArr);
            } else {
                setGushimList([]);
            }
        } else {
            // get the data from local storage
            const storedGushimData = JSON.parse(localStorage.getItem('gushim'));
            if (storedGushimData) {
                const gushimData = storedGushimData.gushimData;

                let gushimArr = [];
                for (let i = 0; i < gushimData.length; i++) {
                    let gushObj = {
                        value: gushimData[i].gush,
                        text: `${gushimData[i].gush + 0}`
                    }
                    gushimArr.push(gushObj);
                }
                setGushimList(gushimArr);
            }
        }
    }

    const getStreetsData = async () => {
        if (isDataStale('streets')) {
            const streetsData = await fetchStreetsList();
        
            if (streetsData && streetsData.length > 0) {
                // Save the data and current date in local storage
                const currentDate = new Date();
                localStorage.setItem('streets', JSON.stringify({ streetsData, lastSavedDate: currentDate }));
    
                let streetsArr = [];
                for (let i = 0; i < streetsData.length; i++) {
                    let streetObj = {
                        value: streetsData[i].Semel,
                        text: streetsData[i].StreetName
                    };
                    streetsArr.push(streetObj);
                }

                setStreetsList(streetsArr);
            } else {
                setStreetsList([]);
            }
        } else {
            // get the data from local storage
            const storedGushimData = JSON.parse(localStorage.getItem('streets'));
            if (storedGushimData) {
                const streetsData = storedGushimData.streetsData;

                let streetsArr = [];
                for (let i = 0; i < streetsData.length; i++) {
                    let streetObj = {
                        value: streetsData[i].Semel,
                        text: streetsData[i].StreetName
                    };
                    streetsArr.push(streetObj);
                }
                setStreetsList(streetsArr);
            }
        }
    }

    const getTabasData = async () => {
        
        if (isDataStale('tabas')) {
            const tabasData = await fetchTabasList(systemCodeURL);

            if (tabasData && tabasData.length > 0) {
                // Save the data and current date in local storage
                const currentDate = new Date();
                localStorage.setItem('tabas', JSON.stringify({ tabasData, lastSavedDate: currentDate }));

                let tabasArr = [];
                for (let i = 0; i < tabasData.length; i++) {
                    const tabaObj = {
                        value: tabasData[i].mezahe,
                        // text: tabasData[i].shem
                        // text: `${tabasData[i].mezahe + 0}`
                        text: `${tabasData[i].mezahe}`
                    };
                    tabasArr.push(tabaObj);
                }
                setTabasList(tabasArr);
            } else {
                setTabasList([]);
            }
        } else {
            // get the data from local storage
            const storedGushimData = JSON.parse(localStorage.getItem('tabas'));
            if (storedGushimData) {
                const tabasData = storedGushimData.tabasData;

                let tabasArr = [];
                for (let i = 0; i < tabasData.length; i++) {
                    const tabaObj = {
                        value: tabasData[i].mezahe,
                        // text: tabasData[i].shem
                        // text: `${tabasData[i].mezahe + 0}`
                        text: `${tabasData[i].mezahe}`
                    };
                    tabasArr.push(tabaObj);
                }
                setTabasList(tabasArr);
            }
        }
    }

    const orderAndRemoveHelkotList = (helkotArr) => {
        //1. fix the helka number
        for (let i = 0; i < helkotArr.length; i++) {
            helkotArr[i].helka = helkotArr[i].helka > 5000 ? helkotArr[i].helka - 5000 : helkotArr[i].helka;
        }

        //2. remove duplicates numbers
        const isObjectEqual = (obj1, obj2) => {
            return obj1.helka === obj2.helka;
        }

        let uniqueArray = helkotArr.filter((obj, index, self) =>
            self.findIndex(otherObj => isObjectEqual(obj, otherObj)) === index
        );

        return uniqueArray;
    }

    const getHelkotByGushId = async (gushId) => {
        let helkotData = await fetchHelkotByGushId(gushId);

        if (helkotData && helkotData.length > 0) {
            let helkotArr = [];
            const helkotAfterOrder = orderAndRemoveHelkotList(helkotData);
            for (let i = 0; i < helkotAfterOrder.length; i++) {
                let helkaObj = {
                    value: helkotAfterOrder[i].helka,
                    text: `${helkotAfterOrder[i].helka + 0}`
                };
                helkotArr.push(helkaObj);
            }
            setHelkotList(helkotArr);
        } else {
            setHelkotList([]);
        }
    }

    //funcs:
    const formatNumber = (input) => {
        // Extract the first 4 digits
        const startNum = input.slice(0, 4);
        if (startNum === "") {
            return ""
        }
        // Extract the next 2 digits
        const endNum = input.slice(4, 6);
        // Create the formatted result
        const formattedNumber = `${startNum}.${endNum}`;
        return formattedNumber;
    };

    const handleTikNumChange = (e) => {
        if (e.value !== undefined && e.value !== null && e.value !== "") {
            const input = e.target.value;
            // Remove non-numeric characters
            const sanitizedInput = input.replace(/[^0-9]/g, '');
            // Limit the input to 6 digits (4 + 2)
            const truncatedInput = sanitizedInput.slice(0, 6);
            // Format the number
            const formattedValue = formatNumber(truncatedInput);
            // Set the formatted value in the state
            setTikNumValue(formattedValue);
            if (tikNumYear.length === 4) {
                setIsBakshaSearch(true);
                //clean all other options
                setMisparGush("");
                setMisparHelka("");
                // setTikNumYear("");
                // setTikNumValue("");
                setStreetNum("");
                setStreetName("");
                setMisparBait("");
                setMisparTaba("");
                setMisparTaShetach("");
                setMisparTikTaba("");
            } else {
                setIsBakshaSearch(false);
            }
        } else {
            setTikNumValue("");
        }
    };

    const pad = (str, max) => {
        str = str.toString();
        return str.length < max ? pad("0" + str, max) : str;
    }

    const buildTikNumberValue = () => {
        let tikNum = tikNumValue;

        let tikNumber = "";
        let tik1 = "";
        let tik2 = "";

        if (tikNum === "" || tikNum === 0) {
            // alert("חובה לקלוט מספר תיק!");
            tikNumber = "0000.00";
        }

        if (tikNum && tikNumYear && tikNumYear.length === 0) {
            tikNumber = tikNum;
        }

        if (tikNum) {
            let pos = tikNum.indexOf(".");
            if (pos === -1) {
                tik2 = ".00";
                tik1 = tikNum;
            }
            else {
                tik1 = tikNum.slice(0, pos);
                tik2 = tikNum.slice(pos + 1);
                tik2 = "." + pad(tik2, 2);
            }
            tik1 = pad(tik1, 4);
            tikNumber = tik1 + tik2;
        }

        setTikNumValue(tikNumber);
        setIsBakshaSearch(true);
    };

    const buildTikYearValue = () => {
        let yearNum = systemCodeURL !== "26400016" ? tikNumYear : misparHeytelYear;
        console.log('yearNum', yearNum);
        if (yearNum) {
            let tikYear = "";
            let currYear = new Date().getFullYear();
            if (yearNum.length === 4 && parseInt(yearNum) <= currYear && parseInt(yearNum) >= 1901) { //1920
                tikYear = yearNum;
            }
            if (yearNum.length === 4 && parseInt(yearNum) > currYear && parseInt(yearNum) < 1901) { //1920
                alert("ערך שדה שנה לא תקין!");
            }
            if (yearNum.length > 0 && yearNum.length <= 2) {
                if (parseInt(yearNum) > currYear - 2000) {
                    tikYear = (parseInt(yearNum) + 1900).toString();
                }
                else {
                    tikYear = (parseInt(yearNum) + 2000).toString();
                }
            }

            if (systemCodeURL !== "26400016") {
                setTikNumYear(tikYear);
            } else {
                setMisparHeytelYear(tikYear);
            }

        } else {
            if (systemCodeURL !== "26400016") {
                setTikNumYear("2000");
                setIsBakshaSearch(true);
            } else {
                setMisparHeytelYear("2000");
            }
        }
    };

    const handleTikNumYearChange = (e) => {
        if (e.value !== undefined && e.value !== null && e.value !== "") {
            const limitYear = 4;
            const input = e.target.value;
            if (input !== "") {
                // Remove non-numeric characters
                const sanitizedInput = input.replace(/[^0-9]/g, '');
                setTikNumYear(sanitizedInput.slice(0, limitYear));
                //clean
                setMisparGush("");
                setMisparHelka("");
                // setTikNumYear("");
                // setTikNumValue("");
                setStreetNum("");
                setStreetName("");
                setMisparBait("");
                setMisparTaba("");
                setMisparTaShetach("");
                setMisparTikTaba("");
                // setIsBakshaSearch(false);
                setIsGushVeHelkaSearch(false);
                setIsStreetNumVeMisparBait(false);
                setIsMisparTabaVeShetach(false);
                setIsMisparTaba(false);
            } else {
                setIsBakshaSearch(false);
                setTikNumYear("");
            }
        } else {
            setTikNumYear("");
        }
    }

    const handleTikTabaChanged = (e) => {
        if (e.value !== undefined && e.value !== null && e.value !== "") {
            setMisparTikTaba(e.target.value);
            setIsMisparTaba(true);
            setMisparGush("");
            setMisparHelka("");
            setTikNumYear("");
            setTikNumValue("");
            setStreetNum("");
            setStreetName("");
            setMisparBait("");
            setMisparTaba("");
            setMisparTaShetach("");

            setIsBakshaSearch(false);
            setIsGushVeHelkaSearch(false);
            setIsStreetNumVeMisparBait(false);
            setIsMisparTabaVeShetach(false);
            // setIsMisparTaba(false);
        } else {
            setMisparTikTaba("");
            setIsMisparTaba(false);
        }
    }

    const handleGushChanged = (e) => {
        if (e.value !== null && e !== "" && e.value.CombinedKey !== 0) {
            setMisparGush(e.value.CombinedKey);
            setTikNumYear("");
            setTikNumValue("");
            setStreetNum("");
            setStreetName("");
            setMisparBait("");
            setMisparTaba("");
            setMisparTaShetach("");
            setMisparTikTaba("");

            // setIsGushVeHelkaSearch(false);
            setIsBakshaSearch(false);
            setIsStreetNumVeMisparBait(false);
            setIsMisparTabaVeShetach(false);
            setIsMisparTaba(false);
        } else {
            setMisparGush("");
            setIsGushVeHelkaSearch(false);
        }
        setMisparHelka("");
    }

    const handleHelkaChanged = (e) => {
        if (e.value !== null && e !== "" && e.value.CombinedKey !== 0) {
            setMisparHelka(e.value.CombinedKey);
            setIsGushVeHelkaSearch(true);
            //clean all other options
        } else {
            setMisparHelka("");
            setIsGushVeHelkaSearch(false);
        }
    }

    const handleStreetChanged = (e) => {
        if (e !== "" && e.value !== null && e.value.CombinedKey !== 0) {
            setStreetNum(e.value.CombinedKey);
            setStreetName(e.value.Description);
            setIsStreetNumVeMisparBait(true);
            //clean all other options
            setTikNumYear("");
            setTikNumValue("");
            setMisparGush("");
            setMisparHelka("");
            setMisparBait("");
            setMisparTaba("");
            setMisparTaShetach("");
            setMisparTikTaba("");

            setIsBakshaSearch(false);
            setIsGushVeHelkaSearch(false);
            // setIsStreetNumVeMisparBait(false);
            setIsMisparTabaVeShetach(false);
            setIsMisparTaba(false);
        } else {
            setStreetNum("");
            setStreetName("");
            setIsStreetNumVeMisparBait(false);
        }
        setMisparBait("");
    }

    const handleTabaChanged = (e) => {
        if (e.value !== null && e !== "" && e.value.CombinedKey !== 0) {
            setMisparTaba(e.value.CombinedKey);
            setIsMisparTabaVeShetach(true);
            setMisparGush("");
            setMisparHelka("");
            setTikNumYear("");
            setTikNumValue("");
            setStreetNum("");
            setStreetName("");
            setMisparBait("");
            setMisparTikTaba("");

            setIsBakshaSearch(false);
            setIsGushVeHelkaSearch(false);
            setIsStreetNumVeMisparBait(false);
            // setIsMisparTabaVeShetach(false);
            setIsMisparTaba(false);
        } else {
            setMisparTaba("");
            setIsMisparTabaVeShetach(false);
        }
        setMisparTaShetach("");
    }

    //Heytel functions:
    const formatHeytelNumber = (input) => {
        // Extract the first 5 digits
        const startNum = input.slice(0, 5);
        if (startNum === "") {
            return ""
        }
        // Extract the next 3 digits
        const endNum = input.slice(5, 8);
        // Create the formatted result
        const formattedNumber = `${startNum}.${endNum}`;
        return formattedNumber;
    }

    const handleHeytelTikChange = (e) => {
        if (e.value !== undefined && e.value !== null && e.value !== "") {
            const input = e.value;
            // Remove non-numeric characters
            const sanitizedInput = input.replace(/[^0-9]/g, '');
            // Limit the input to 8 digits (5 + 3)
            const truncatedInput = sanitizedInput.slice(0, 8);
            // Format the number
            const formattedValue = formatHeytelNumber(truncatedInput);
            // Set the formatted value in the state
            setMisparHeytelTik(formattedValue);
            setMisparTofes("");
            setMisparAsmachta("");
        }
    }

    const buildHeytelTikNumber = () => {
        let tikNum = misparHeytelTik;

        let tikNumber = "";
        let tik1 = "";
        let tik2 = "";

        // if ((tikNum === "" || tikNum === 0 ? 0 : tikNum.toString().length) === 0) {
        if (tikNum === "" || tikNum === 0) {
            // alert("חובה לקלוט מספר תיק!");
            tikNumber = "00000.000";
        }

        if (tikNum && tikNumYear && tikNumYear.length === 0) {
            tikNumber = tikNum;
        }

        if (tikNum) {
            let pos = tikNum.indexOf(".");
            if (pos === -1) {
                tik2 = ".000";
                tik1 = tikNum;
            } else {
                tik1 = tikNum.slice(0, pos);
                tik2 = tikNum.slice(pos + 1);
                tik2 = "." + pad(tik2, 3);
            }
            tik1 = pad(tik1, 5);
            tikNumber = tik1 + tik2;
        }

        setMisparHeytelTik(tikNumber);
        // setIsBakshaSearch(true);
    }

    const handleHeytelYearChange = (e) => {
        if (e.value !== undefined && e.value !== null && e.value !== "") {
            const limitYear = 4;
            const input = e.value;
            if (input !== "") {
                // Remove non-numeric characters
                const sanitizedInput = input.replace(/[^0-9]/g, '');
                setMisparHeytelYear(sanitizedInput.slice(0, limitYear));
                setMisparTofes("");
                setMisparAsmachta("");
            } else {
                setMisparHeytelYear("");
            }
        } else {
            setMisparHeytelYear("");
        }
    }

    const handleAsmachtaChanged = (e) => {
        if (e.value !== null && e !== "") {
            setMisparAsmachta(e.value);
            setMisparHeytelTik("");
            setMisparHeytelYear("");
            setMisparTofes("");
        } else {
            setMisparAsmachta("");
        }
    }

    const handleTofetChanged = (e) => {
        if (e.value !== null && e !== "") {
            setMisparTofes(e.value);
            setMisparHeytelTik("");
            setMisparHeytelYear("");
            setMisparAsmachta("");
        } else {
            setMisparTofes("");
        }
    }

    const searchTik = async () => {
        // setIsLoading(true);

        let misparTikValue;
        let misparGushValue;
        let misparHelkaValue;
        let streetNumValue;
        let misparBaitValue;
        let misparTabaValue;
        let misparTaShetachValue;

        if (isBakshaSerch) {
            misparTikValue = `${tikNumYear}/${tikNumValue}`
        } else {
            misparTikValue = null;
        }

        if (isGushVeHelkaSearch) {
            misparGushValue = misparGush;
            misparHelkaValue = misparHelka;
        } else {
            misparGushValue = null;
            misparHelkaValue = null;
        }

        if (isStreetNumVeMisparBait) {
            streetNumValue = streetNum !== "" ? streetNum : null;
            misparBaitValue = misparBait !== "" ? misparBait : null;
        } else {
            streetNumValue = null;
            misparBaitValue = null;
        }

        if (isMisparTabaVeShetach) {
            misparTabaValue = misparTaba;
            misparTaShetachValue = misparTaShetach !== "" ? misparTaShetach : null;
        } else {
            misparTabaValue = null;
            misparTaShetachValue = null;
        }

        if (!isBakshaSerch && !isGushVeHelkaSearch && !isStreetNumVeMisparBait && !isMisparTabaVeShetach) {
            alert("נא למלא את השדות המתאימים לפני איתור תיק!");
            // setIsLoading(false);
        } else {
            const dataToSerach = {
                misparTik: misparTikValue,
                gush: misparGushValue,
                helka: misparHelkaValue,
                rehovCode: streetNumValue,
                rehovName: streetName,
                mispBait: misparBaitValue,
                mezahe: misparTabaValue,
                migrash: misparTaShetachValue,
                systemId: systemCodeURL //26400046
            }

            if (systemCodeURL === "26400046") {
                // setIsLoading(false);
                props.handleRishuiSearch(dataToSerach);
            } else {
                props.searchTikPikuah(dataToSerach);
            }
        }
    }

    const searchTikTaba = async () => {
        // setIsLoading(true);

        let misparTikTabaValue;
        let misparGushValue;
        let misparHelkaValue;
        let streetNumValue;
        let misparBaitValue;

        if (isMisparTaba) {
            misparTikTabaValue = misparTikTaba
        } else {
            misparTikTabaValue = null;
        }

        if (isGushVeHelkaSearch) {
            misparGushValue = misparGush;
            misparHelkaValue = misparHelka;
        } else {
            misparGushValue = null;
            misparHelkaValue = null;
        }

        if (isStreetNumVeMisparBait) {
            streetNumValue = streetNum !== "" ? streetNum : null;
            misparBaitValue = misparBait !== "" ? misparBait : null;
        } else {
            streetNumValue = null;
            misparBaitValue = null;
        }

        if (!isMisparTaba && !isGushVeHelkaSearch && !isStreetNumVeMisparBait) {
            alert("נא למלא את השדות המתאימים לפני איתור תיק תב''ע!");
        } else {
            const tabaDataToSerach = {
                misparTaba: misparTikTabaValue,
                gush: misparGushValue,
                helka: misparHelkaValue,
                rehovCode: streetNumValue,
                rehovName: streetName,
                mispBait: misparBaitValue,
                systemId: systemCodeURL
            }


            // setIsLoading(false);
            props.searchTaba(tabaDataToSerach);
        }
    }

    const calcBtnDisabled = () => {
        if (misparHeytelYear !== "" && misparHeytelTik !== "") {
            return false;
        } else if (misparAsmachta !== "") {
            return false;
        } else if (misparTofet !== "") {
            return false;
        } else {
            return true;
        }
    }

    const searchHeytelTik = () => {
        let misparTikHeytel, asmahtaHeytelNum, tofesInternetHeytelNum;
        if (misparHeytelYear !== "" && misparHeytelTik !== "") {
            misparTikHeytel = `${misparHeytelYear}/${misparHeytelTik}`;
            asmahtaHeytelNum = null;
            tofesInternetHeytelNum = null;
        } else if (misparAsmachta !== "") {
            misparTikHeytel = null;
            asmahtaHeytelNum = misparAsmachta;
            tofesInternetHeytelNum = null;
        } else {
            misparTikHeytel = null;
            asmahtaHeytelNum = null;
            tofesInternetHeytelNum = misparTofet;
        }

        const tabaDataToSerach = {
            misparTik: misparTikHeytel,
            asmahtaNum: asmahtaHeytelNum,
            tofesInternetNum: tofesInternetHeytelNum
        }

        props.seacrhHeytel(tabaDataToSerach);
    }

    const handleOpenWebPage = () => {
        const url = `https://jergisinfohub.jerusalem.muni.il/UI/GisMeidaT/index.html?street=${streetNum}&house=${misparBait}&gush=${misparGush}&helka=${misparHelka}&taba=${misparTaba}&migrash=${misparTaShetach}`
        window.open(`${url}`,"_blank");
    }

    return (
        <div>
            <div className="formbox-group" dir="rtl">
                <div className="formbox-group-box formbox-group-box--description">
                    <div className="d-flex flex-column align-items-center justify-content-center h-100">
                        {/* <MissileArrowSvg /> */}
                        <SvgIcon icon="folder-with-papers" keepColor={true} style={{ fontSize: '5.75rem' }} />
                        {/* <Missile /> */}
                        {
                            systemCodeURL === "26400046" ?
                                <div className="fs-4 lh-sm text-center mt-2 mt-md-4">
                                    <b>ברוכים הבאים למערכת "איתור</b>
                                    <br />
                                    <b>נתונים בתיק רישוי בניה"</b>
                                    <br />
                                    באיזור זה תוכלו לצפות בסטטוס תיק
                                    <br />
                                    הרישוי שלך וכן לעקוב אחר ההחלטות
                                    הנוגעות לתיק.
                                </div>
                                :
                                (
                                    systemCodeURL === "26400056" ?
                                        <div className="fs-4 lh-sm text-center mt-2 mt-md-4">
                                            <b>ברוכים הבאים למערכת "איתור</b>
                                            <br />
                                            <b>נתונים בתיק פיקוח בניה"</b>
                                            <br />
                                            באיזור זה תוכלו לצפות בסטטוס תיק
                                            <br />
                                            הפיקוח שלך וכן לעקוב אחר ההחלטות
                                            הנוגעות לתיק.
                                        </div>
                                        :
                                        (
                                            systemCodeURL === "26400001" ?
                                                <div className="fs-4 lh-sm text-center mt-2 mt-md-4">
                                                    <b>ברוכים הבאים למערכת "איתור</b>
                                                    <br />
                                                    <b>נתונים בתיק תב''ע"</b>
                                                    <br />
                                                    באיזור זה תוכלו לצפות בסטטוס תיק
                                                    <br />
                                                    התב''ע שלך וכן לעקוב אחר ההחלטות
                                                    הנוגעות לתיק.
                                                </div>
                                                :
                                                // systemCodeURL === 26400016
                                                <div className="fs-4 lh-sm text-center mt-2 mt-md-4">
                                                    <b>ברוכים הבאים למערכת "איתור</b>
                                                    <br />
                                                    <b>נתונים בהיטל השבחה"</b>
                                                    <br />
                                                    באיזור זה תוכלו לצפות בסטטוס התיק
                                                    <br />
                                                    שלך וכן לעקוב אחר ההחלטות
                                                    הנוגעות לתיק.
                                                </div>
                                        )
                                )
                        }
                    </div>
                </div>

                <div className="formbox-group-box" >
                    <div className="form">
                        {
                            systemCodeURL === "26400046" || systemCodeURL === "26400056" ?
                                <div className="row gx-2 gx-md-4">
                                    <span className={"col-6"}>
                                        <Input
                                            className="k-input"
                                            label="מספר תיק"
                                            type="text"
                                            value={tikNumValue}
                                            placeholder='xxxx.xx'
                                            onChange={handleTikNumChange}
                                            onBlur={() => buildTikNumberValue()}
                                            onKeyUp={(e) => e.key === 'Enter' && buildTikNumberValue()}
                                        />
                                    </span>

                                    <span className={"col-1"} style={{ fontSize: "xxx-large", padding: "25px 5px 0px 5px" }}>/</span>

                                    <span className={"col-5"}>
                                        <Input
                                            label="שנה"
                                            type="text"
                                            value={tikNumYear}
                                            placeholder='xxxx'
                                            onChange={handleTikNumYearChange}
                                            onBlur={() => buildTikYearValue()}
                                            onKeyUp={(e) => e.key === 'Enter' && buildTikYearValue()}
                                        />
                                    </span>
                                </div>
                                :
                                (
                                    systemCodeURL === "26400001" ?
                                        <div className="row gx-2 gx-md-4">
                                            <span className={"col-12"}>

                                                <Input
                                                    label="מספר תיק"
                                                    type="text"
                                                    style={{ width: "100%" }}
                                                    value={misparTikTaba}
                                                    onChange={handleTikTabaChanged}
                                                />
                                            </span>

                                        </div>
                                        :
                                        // היטל השבחה:
                                        <div className="row gx-2 gx-md-4">
                                            <span className={"col-6"}>
                                                <Input
                                                    className="k-input"
                                                    label="מספר תיק"
                                                    type="text"
                                                    value={misparHeytelTik}
                                                    placeholder='xxxxx.xxx'
                                                    onChange={handleHeytelTikChange}
                                                    onBlur={() => buildHeytelTikNumber()}
                                                    onKeyUp={(e) => e.key === 'Enter' && buildHeytelTikNumber()}
                                                />
                                            </span>

                                            <span className={"col-1"} style={{ fontSize: "xxx-large", padding: "25px 5px 0px 5px" }}>/</span>

                                            <span className={"col-5"}>
                                                <Input
                                                    label="שנה"
                                                    type="text"
                                                    value={misparHeytelYear}
                                                    placeholder='xxxx'
                                                    onChange={handleHeytelYearChange}
                                                    onBlur={() => buildTikYearValue()}
                                                    onKeyUp={(e) => e.key === 'Enter' && buildTikYearValue()}
                                                />
                                            </span>
                                        </div>
                                )
                        }

                        <OrHrDivider />

                        {
                            systemCodeURL !== "26400016" ?
                                <>
                                    <div className="row gx-2 gx-md-4">
                                        <span className={"col-6"}>
                                            <GenCombobox
                                                baseUrl={''}
                                                cnn={''}
                                                label="גוש"
                                                data={gushimList}
                                                value={misparGush}
                                                onChangeFunc={handleGushChanged}
                                            />
                                        </span>

                                        <span className={"col-6"}>
                                            <GenCombobox
                                                baseUrl={''}
                                                cnn={''}
                                                label="חלקה"
                                                data={helkotList}
                                                value={misparHelka}
                                                required={misparGush !== "" ? true : false}
                                                onChangeFunc={handleHelkaChanged}
                                            />
                                        </span>

                                    </div>

                                    <OrHrDivider />

                                    <div className="row gx-2 gx-md-4">
                                        <span className={"col-8"}>
                                            <GenCombobox
                                                baseUrl={''}
                                                cnn={''}
                                                label="רחוב"
                                                data={streetsList}
                                                value={streetNum}
                                                onChangeFunc={handleStreetChanged}
                                            />
                                        </span>

                                        <span className={"col-4"}>
                                            <Input
                                                label="בית"
                                                type="number"
                                                value={misparBait}
                                                onChange={(e) => setMisparBait(e.target.value)}
                                            />
                                        </span>
                                    </div>

                                    {
                                        systemCodeURL === "26400046" || systemCodeURL === "26400056" ?
                                            <>
                                                <OrHrDivider />
                                                <div className="row gx-2 gx-md-4">
                                                    <span className={"col-8"}>

                                                        <GenCombobox
                                                            baseUrl={''}
                                                            cnn={''}
                                                            label="תב''ע"
                                                            data={tabasList}
                                                            value={misparTaba}
                                                            onChangeFunc={handleTabaChanged}
                                                        />
                                                    </span>

                                                    <span className={"col-4"}>
                                                        <Input
                                                            label="תא שטח"
                                                            type="number"
                                                            value={misparTaShetach}
                                                            onChange={(e) => setMisparTaShetach(e.target.value)}
                                                        />
                                                    </span>
                                                </div>
                                            </>
                                            :
                                            ""
                                    }
                                </>
                                :
                                <>
                                    <div className="row gx-2 gx-md-4">
                                        <span className={"col-12"}>
                                            <Input
                                                label="מספר אסמכתא"
                                                type="text"
                                                style={{ width: "100%" }}
                                                value={misparAsmachta}
                                                onChange={handleAsmachtaChanged}
                                            />
                                        </span>
                                    </div>

                                    <OrHrDivider />

                                    <div className="row gx-2 gx-md-4">
                                        <span className={"col-12"}>
                                            <Input
                                                label="מספר טופס מקוון"
                                                type="text"
                                                style={{ width: "100%" }}
                                                value={misparTofet}
                                                onChange={handleTofetChanged}
                                            />
                                        </span>
                                    </div>
                                </>
                        }



                        <div className="k-form-buttons" style={{ justifyContent: "center" }}>
                            {
                                systemCodeURL === "26400046" || systemCodeURL === "26400056" ?
                                    <>
                                        <Button
                                            style={{ backgroundColor: "#ec9f0a", color: "white", fontWeight: "bold", fontSize: "20px", margin: "10px", padding: "15px", width: "250px" }}
                                            className={`search-btn ${isLoading ? "is-loading" : ""}`}
                                            onClick={searchTik}
                                            disabled={!isBakshaSerch && !isGushVeHelkaSearch && !isStreetNumVeMisparBait && !isMisparTabaVeShetach}
                                        >
                                            {
                                                systemCodeURL === "26400046" ?
                                                    `אתר תיק רישוי`
                                                    :
                                                    `אתר תיק פיקוח`
                                            }
                                        </Button>
                                        {
                                            (systemCodeURL === "26400046" && (isGushVeHelkaSearch || isStreetNumVeMisparBait || isMisparTabaVeShetach)) ?
                                                <Button 
                                                    style={{ backgroundColor: "#ec9f0a", color: "white", fontWeight: "bold", fontSize: "25px", margin: "10px", padding: "15px", width: "250px" }}
                                                    onClick={handleOpenWebPage}
                                                >
                                                    מידע תכנוני מקיף
                                                </Button>
                                                :
                                                ""
                                        }
                                    </>
                                    :
                                    (
                                        systemCodeURL === "26400001" ?
                                            <>
                                                <Button
                                                    style={{ backgroundColor: "#ec9f0a", color: "white", fontWeight: "bold", fontSize: "20px", margin: "10px", padding: "15px", width: "250px" }}
                                                    className={`search-btn ${isLoading ? "is-loading" : ""}`}
                                                    onClick={searchTikTaba}
                                                    disabled={!isMisparTaba && !isGushVeHelkaSearch && !isStreetNumVeMisparBait && !isMisparTabaVeShetach}
                                                >
                                                    אתר תיק תב''ע
                                                </Button>
                                                {
                                                    (isGushVeHelkaSearch || isStreetNumVeMisparBait || isMisparTabaVeShetach) ? 
                                                    <Button 
                                                        style={{ backgroundColor: "#ec9f0a", color: "white", fontWeight: "bold", fontSize: "25px", margin: "10px", padding: "15px", width: "250px" }}
                                                        onClick={handleOpenWebPage}
                                                    >
                                                        מידע תכנוני מקיף
                                                    </Button>
                                                    :
                                                    ""
                                                }
                                            </>
                                            :
                                            <Button
                                                style={{ backgroundColor: "#ec9f0a", color: "white", fontWeight: "bold", fontSize: "20px", margin: "10px", padding: "15px", width: "250px" }}
                                                className={`search-btn ${isLoading ? "is-loading" : ""}`}
                                                onClick={searchHeytelTik}
                                                disabled={calcBtnDisabled()}
                                            >
                                                אתר תיק היטל השבחה
                                            </Button>
                                    )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TikRishuiRegistration